import styled from 'styled-components';

const StyledFeaturedCarousel = styled.div`
  padding-top: ${props => props.theme.components_spacing_desk.xlarge}px;
  padding-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  margin-bottom: ${props => props.isArticle ? 0 : props.theme.components_spacing_desk.xlarge}px;
  background-color: ${props => props.isArticle ? 'transparent' : '#f2f2f2' };
  padding-right: 64px;
  padding-left: 64px;
  .paragraph--col-wrap{
    padding: 0 !important;
    justify-content: space-between;
  }
  .paragraph--col-big h6 {
    margin-bottom: 32px;
  }
  .paragraph--col-big p {
    color: #4d4d4d;
  }  
  .paragraph--col-small{
    flex: 0 0 auto;
  }
  .carousel-featured{
    margin-top: 80px;
  }
  .category{
    text-transform: uppercase;
    padding: 14px 0;
    margin-bottom: 16px;
    cursor: pointer;
    color: ${ props => props.theme.colors.green_secondary};
  }
  .big--title{
    cursor: pointer;
  }
  .details-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #4D4D4D;
    margin-top: 24px;
    flex-wrap: wrap;
  }
  .detail-col{
    display: flex;
    align-items: center;
    margin-right: 24px;
    margin-bottom: 16px;
  }
  .detail-col p {
    white-space: nowrap;
  }
  .detail-col img {
    margin-right: 8px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
  }
  @media screen and (max-width: 1023px){
    .paragraph--col-big h6 {
      margin-bottom: 24px;
    }
    .carousel-featured{
      margin-top: 64px;
    }
    padding-top: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
  }
  @media screen and (max-width: 767px){
    .paragraph--col-big h6 {
      margin-bottom: 0;
    }
    .carousel-featured{
      margin-top: 40px;
    }
    .paragraph--col-small{
      margin: 10px 0;
    }
    padding-right: 24px;
    padding-left: 24px;
    padding-top: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    padding-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
  }
  .swiper-slide{
    width: 41.65%;
  }
  .swiper-button-next {
    background-image: url(/arrow-next-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    right: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  .swiper-button-disabled{
    display: none;
  }
  .swiper-button-next::after {
    display: none;
  }
  .swiper-button-prev {
    background-image: url(/arrow-prev-carousel.svg);
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
    width: 64px;
    height: 64px;
    left: 64px;
    background-color: #000;
    border-radius: 50%;
    transition: background-color .25s;
  }
  .swiper-button-prev::after{
    display: none;
  }
  .swiper-button-prev:hover, .swiper-button-next:hover{
    background-color: ${props => props.theme.colors.green_secondary};
  }
  @media screen and (max-width: 1439px){
    .swiper-button-next {
      right: 40px
    }
    .swiper-button-prev {
      left: 40px
    }

  }
  @media screen and (max-width: 767px){
    .swiper-slide{
      width: 66.66%;
    }
    .swiper-button-next,
    .swiper-button-prev{
      width: 44px;
      height: 44px;
      padding: 6px;
      background-color: transparent;
    }
    .swiper-button-next:hover,
    .swiper-button-prev:hover{
      background-color: transparent;
    }
    .swiper-button-next{
      right: 24px
    }
    .swiper-button-prev{
      left: 24px
    }
    .swiper-button-next::after,
    .swiper-button-prev::after {
      content: '';
      display: block;
      border-radius: 50%;
      background-color: #000;
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center;
    }
    .swiper-button-next::after{
      background-image: url(/arrow-next-carousel.svg);
    }
    .swiper-button-prev::after{
      background-image: url(/arrow-prev-carousel.svg);
    }
  }s
`;

export {
  StyledFeaturedCarousel
};

